import Vue from 'vue'
import Vuex from 'vuex'
import {getUserInfo} from '@/api/getData'
import {getStore} from '@/config/mUtils'
import router from '../router';
Vue.use(Vuex)

const state = {
    adminInfo: {
        avatar: ''
    },
    userInfo:{},
    achievement:{},
    course:{},
    activity:{},
    path:'home',
    sHeight:560,
    currentActivity:'',
    prePath:'',
}

const mutations = {
    saveAdminInfo(state, adminInfo){
        state.adminInfo = adminInfo;
    },
    saveUserInfo(state,userinfo){
        state.userInfo=userinfo
    },
    saveAchievement(state,res){
        state.achievement=res;
    },
    saveCourse(state,res){
        state.course=res;
    },
    saveActivity(state,res){
        state.activity=res;
    },
    savePath(state,res){
        state.path=res;
    },
    saveSHeight(state,res){
        state.sHeight=res;
    },
    saveCurrentActivity(state,res){
        state.currentActivity=res;
    },
    savePrePath(state,res){
        state.prePath=res
    }
}

const actions = {

}



export default new Vuex.Store({
    state,
    actions,
    mutations,
})



// WEBPACK FOOTER //
// ./src/store/index.js